// H5 / PAD viewport 管理
// 需求：PAD 终端的页面样式和交互与 H5 手机端保持完全一致。
// 实现方式：PAD 继续走 H5 路由，但通过固定 layout viewport 宽度，让浏览器自动等比缩放整个页面到 PAD 屏幕。
// 横屏时固定宽度会导致内容被过度放大（文字/按钮过大），因此横屏切换为设备宽度，由居中容器 + 响应式扩宽兜底。

import { isPadDevice } from './device'

// H5 设计稿/最大内容宽度基准。
// 项目里 .mobile-container 的 max-width 为 540px，因此以 540 作为参考宽度，
// 可以覆盖 iPhone Plus/Max 等大屏手机下的 H5 表现，并在 PAD 上等比放大。
const PAD_VIEWPORT_WIDTH = 540

/**
 * 判断当前是否为横屏（基于 layout viewport 宽高比）
 * 即使 viewport 被固定为 540，竖屏时 innerHeight > 540、横屏时 innerHeight < 540，因此依然判断准确。
 */
function isLandscape() {
  return typeof window !== 'undefined' && window.innerWidth > window.innerHeight
}

/**
 * 设置 viewport meta，区分手机与 PAD：
 * - 手机：标准响应式 viewport
 * - PAD 竖屏：固定宽度为 PAD_VIEWPORT_WIDTH，由浏览器自动缩放至屏幕宽度，保持 H5 样式/交互不变
 * - PAD 横屏：切换为设备宽度，避免 540 固定宽度被过度放大；配合居中容器（.mobile-page-pad-wrap）与响应式扩宽兜底
 * 说明：isPadDevice() 在 device.js 中已做缓存，不会因 viewport 变化导致 PAD 判定抖动。
 */
export function setupViewport() {
  if (typeof document === 'undefined') return
  let meta = document.querySelector('meta[name="viewport"]')
  if (!meta) {
    meta = document.createElement('meta')
    meta.name = 'viewport'
    document.head.appendChild(meta)
  }
  if (isPadDevice()) {
    if (isLandscape()) {
      meta.content = 'width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no,viewport-fit=cover'
    } else {
      meta.content = `width=${PAD_VIEWPORT_WIDTH}, user-scalable=no, viewport-fit=cover`
    }
  } else {
    meta.content = 'width=device-width,initial-scale=1.0,viewport-fit=cover'
  }
}

/**
 * 初始化 viewport，并监听屏幕旋转/尺寸变化时重新判定
 */
export function initViewport() {
  if (typeof window === 'undefined') return
  setupViewport()
  window.addEventListener('resize', setupViewport)
  window.addEventListener('orientationchange', setupViewport)
}
